export default {
  filterData : {
    Products: {
      label: 'Producten',
      allFilterLabel: "Alle producten",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "Onderwerpen",
      allFilterLabel: "Alle onderwerpen",
      items: [
        { name: "Toegangsbeheer", id: "Access management" },
        { name: "Analytics en monitoring", id: "Analytics and monitoring" },
        { name: "Application delivery en security", id: "Application delivery and security" },
        { name: "Citrix en Google", id: "Citrix and Google" },
        { name: "Citrix en Microsoft", id: "Citrix and Microsoft" },
        { name: "Cloudmigratie", id: "Cloud migration" },
        { name: "Vergelijken", id: "Compare" },
        { name: "Content collaboration", id: "Content collaboration" },
        { name: "Digitale workspaces", id: "Digital workspaces" },
        { name: "Een goede werknemerservaring", id: "Employee experience" },
        { name: "Hybride cloud", id: "Hybrid cloud" },
        { name: "Hybride werken", id: "Hybrid work" },
        { name: "Beheren en optimaliseren", id: "Manage and optimize" },
        { name: "Microservices en DevOps", id: "Microservices and devOps" },
        { name: "Onboarding en adoptie", id: "Onboarding and adoption" },
        { name: "Partnerintegraties", id: "Partner integrations" },
        { name: "Productoverzicht", id: "Product overview" },
        { name: "Security en compliance", id: "Security and compliance" },
        { name: "Kleine organisaties", id: "Small business" },
        { name: "Specificaties", id: "Specifications" },
        { name: "Duurzaamheid", id: "Sustainability" },
        { name: "Unified endpoint management", id: "Unified endpoint management" },
        { name: "VDI en DaaS", id: "VDI and DaaS" },
      ],
    }, 
    Type: {
      label: 'Type',
      allFilterLabel: "Alle typen",
      items: [
        { name: "Analyserapport", id: "Analyst report" },
        { name: "Assessment tool", id: "Assessment tool" },
        { name: "Klantverhaal", id: "Customer story" },
        { name: "Datasheet", id: "Data sheet" },
        { name: "Demo", id: "Demo" },
        { name: "E-book", id: "eBook" },
        { name: "Sturen", id: "Guide" },
        { name: "Infographic", id: "Infographic" },
        { name: "Interactieve rondleiding", id: "Interactive tour" },
        { name: "Podcast", id: "Podcast" },
        { name: "Resourcekit", id: "Resource kit" },
        { name: "Solution brief", id: "Solution brief" },
        { name: "Technisch overzicht", id: "Technical brief" },
        { name: "Video", id: "Video" },
        { name: "Webinar", id: "Webinar" },
        { name: "Whitepaper", id: "White paper" },
      ]
    },
    Industry: {
      label: "Sector",
      allFilterLabel: "Alle sectoren",
      items: [
        { name: "Onderwijs", id: "education" },
        { name: "Financiële dienstverlening", id: "financial_service" },
        { name: "Overheid", id: "government" },
        { name: "Gezondheidszorg", id: "healthcare" },
        { name: "Productie", id: "manufacturing" },
        { name: "Retail", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "Zoeken in bibliotheek",
    titles : {
      label1: "Nu trending",
      label2: "Nieuwste materiaal",
      label3: "Onlangs bekeken",
      label4: "Aanbevolen bronnen"
    },
    showMoreLabel: "Meer tonen",
    clearAllSelected: "Volledige selectie opheffen",
    searchResults: "Zoekresultaten voor",
    clearAllFilters: "Alle filters wissen",
    noResultsFound: "Er zijn geen artikelen die aan uw geselecteerde criteria voldoen",
    resetView: "Weergave resetten",
    filterLabel: "Filter",
    filteredRes: "Gefilterde resultaten",
    filterRes: "Uw resultaten filteren",
    clearAllCta: "Alles wissen",
    applyCta: "Toepassen",
    view: "Weergeven",
    includeEnglishRes: "Inclusief materiaal in het Engels"
  };
